(function () {
  const THRESHOLD_CENTS = 150000;
  const QUALIFIED_STORAGE_KEY = 'stylemeghdFreeShippingQualified';

  const openLockSvg = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6b7c5e" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 9.9-1"/><circle cx="12" cy="16.5" r="1.5" fill="#6b7c5e" stroke="none"/></svg>';
  const closedLockSvg = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9a8e82" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/><circle cx="12" cy="16.5" r="1.5" fill="#9a8e82" stroke="none"/></svg>';

  let latestShippingEligibleTotal = null;
  let refreshTimer = null;
  let observerTimer = null;
  const productJsonCache = new Map();

  function formatMoney(cents) {
    const amount = Math.max(cents, 0) / 100;
    const currency = window.Shopify && Shopify.currency && Shopify.currency.active ? Shopify.currency.active : 'USD';

    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
      minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
      maximumFractionDigits: cents % 100 === 0 ? 0 : 2
    }).format(amount);
  }

  function formatShippingRemaining(cents) {
    if (cents > 0 && cents < 100) {
      return 'less than $1';
    }

    return formatMoney(cents);
  }

  function setQualifiedStorage(qualified) {
    try {
      window.sessionStorage.setItem(QUALIFIED_STORAGE_KEY, qualified ? 'true' : 'false');
    } catch (error) {
      // Storage can be unavailable in some privacy modes; the UI still updates without animation memory.
    }
  }

  function getQualifiedStorage() {
    try {
      return window.sessionStorage.getItem(QUALIFIED_STORAGE_KEY);
    } catch (error) {
      return null;
    }
  }

  function includesAny(value, needles) {
    const text = String(value || '').toLowerCase();
    return needles.some((needle) => text.includes(needle));
  }

  function isPackageProtectionItem(item) {
    if (!item) {
      return false;
    }

    const fields = [
      item.product_title,
      item.title,
      item.variant_title,
      item.vendor,
      item.product_vendor,
      item.product_type,
      item.handle,
      item.sku
    ];

    if (includesAny(fields.join(' '), ['package protection', 'redo'])) {
      return true;
    }

    const properties = item.properties || {};
    const propertyText = Array.isArray(properties)
      ? properties.map((property) => [property.name, property.value].join(' ')).join(' ')
      : Object.keys(properties).map((key) => [key, properties[key]].join(' ')).join(' ');

    return includesAny(propertyText, ['package protection', 'redo']);
  }

  function getLineItemTotal(item) {
    if (!item) {
      return 0;
    }

    if (typeof item.final_line_price === 'number') {
      return item.final_line_price;
    }

    if (typeof item.line_price === 'number') {
      return item.line_price;
    }

    if (typeof item.price === 'number' && typeof item.quantity === 'number') {
      return item.price * item.quantity;
    }

    return 0;
  }

  function getShippingEligibleTotal(cart) {
    if (!cart) {
      return 0;
    }

    if (!Array.isArray(cart.items)) {
      return typeof cart.total_price === 'number' ? cart.total_price : 0;
    }

    return cart.items.reduce((total, item) => {
      return total + (isPackageProtectionItem(item) ? 0 : getLineItemTotal(item));
    }, 0);
  }

  function updateShippingBars(shippingEligibleTotal, allowAnimation) {
    latestShippingEligibleTotal = Number.isFinite(shippingEligibleTotal) ? shippingEligibleTotal : 0;

    const qualified = latestShippingEligibleTotal >= THRESHOLD_CENTS;
    const previousQualified = getQualifiedStorage();
    const shouldAnimate = allowAnimation && previousQualified === 'false' && qualified;
    const progress = Math.min((latestShippingEligibleTotal / THRESHOLD_CENTS) * 100, 100);
    const remaining = Math.max(THRESHOLD_CENTS - latestShippingEligibleTotal, 0);
    const message = qualified
      ? 'Your order qualifies for free shipping.'
      : `You're <strong>${formatShippingRemaining(remaining)}</strong> away from free shipping.`;

    document.querySelectorAll('[data-sm-cart-shipping-progress]').forEach((bar) => {
      const icon = bar.querySelector('[data-sm-cart-shipping-icon]');
      const text = bar.querySelector('[data-sm-cart-shipping-message]');

      bar.dataset.cartTotal = String(latestShippingEligibleTotal);
      bar.dataset.shippingEligibleTotal = String(latestShippingEligibleTotal);
      bar.dataset.qualified = qualified ? 'true' : 'false';
      bar.style.setProperty('--sm-cart-shipping-progress', `${progress}%`);
      bar.classList.toggle('is-qualified', qualified);

      if (icon && icon.dataset.state !== (qualified ? 'open' : 'closed')) {
        icon.innerHTML = qualified ? openLockSvg : closedLockSvg;
        icon.dataset.state = qualified ? 'open' : 'closed';
      }

      if (text && text.innerHTML !== message) {
        text.innerHTML = message;
      }

      if (shouldAnimate) {
        bar.classList.remove('is-unlocking');
        void bar.offsetWidth;
        bar.classList.add('is-unlocking');
        window.setTimeout(() => bar.classList.remove('is-unlocking'), 1000);
      }
    });

    setQualifiedStorage(qualified);
    updateShippingEstimatorRates();
  }

  function syncBarsFromMarkup() {
    const bars = document.querySelectorAll('[data-sm-cart-shipping-progress]');
    if (!bars.length) {
      return;
    }

    const firstBar = bars[0];
    const total = Number(firstBar.dataset.shippingEligibleTotal || firstBar.dataset.cartTotal || 0);

    if (latestShippingEligibleTotal === null) {
      const qualified = total >= THRESHOLD_CENTS;
      if (getQualifiedStorage() === null) {
        setQualifiedStorage(qualified);
      }
    }

    updateShippingBars(latestShippingEligibleTotal === null ? total : latestShippingEligibleTotal, false);
  }

  function refreshCart(allowAnimation = true) {
    window.clearTimeout(refreshTimer);

    refreshTimer = window.setTimeout(() => {
      fetch(`${window.Shopify && Shopify.routes ? Shopify.routes.root : '/'}cart.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      })
        .then((response) => (response.ok ? response.json() : null))
        .then((cart) => {
          if (cart && typeof cart.total_price === 'number') {
            updateShippingBars(getShippingEligibleTotal(cart), allowAnimation);
          }
        })
        .catch(() => {
          syncBarsFromMarkup();
        });
    }, 150);
  }

  function refreshCartAfterDeferredRendering() {
    [600, 1500, 3000].forEach((delay) => {
      window.setTimeout(() => refreshCart(false), delay);
    });
  }

  function updateShippingEstimatorRates() {
    const shippingEligibleTotal = latestShippingEligibleTotal;

    if (shippingEligibleTotal === null) {
      return;
    }

    document.querySelectorAll('shipping-estimator').forEach((estimator) => {
      const region = estimator.querySelector('[role="region"]');
      const items = region ? region.querySelectorAll('li') : [];
      let hasFreeRate = false;

      items.forEach((item) => {
        const isFreeRate = /free shipping over \$?1,?500/i.test(item.textContent || '') || /usd\s*0\.00/i.test(item.textContent || '');
        item.toggleAttribute('data-sm-free-rate', isFreeRate);
        item.toggleAttribute('data-sm-non-free-rate', !isFreeRate);

        if (isFreeRate) {
          hasFreeRate = true;
        }
      });

      estimator.dataset.smFreeQualified = hasFreeRate && shippingEligibleTotal >= THRESHOLD_CENTS ? 'true' : 'false';
    });
  }

  function shouldRefreshFromEventTarget(target) {
    return Boolean(
      target &&
      target.closest &&
      target.closest('cart-drawer, .cart-page, product-form, line-item-quantity, cart-discount-remove-button')
    );
  }

  function installPackageProtectionVisibilityOverride() {
    if (document.getElementById('sm-redo-cart-page-visibility-fix')) {
      return;
    }

    const style = document.createElement('style');
    style.id = 'sm-redo-cart-page-visibility-fix';
    style.textContent = [
      '.cart-page tr:has(.sm-cart-line-item--package-protection){display:table-row!important;visibility:visible!important;}',
      '.cart-page .sm-cart-line-item--package-protection{display:grid!important;visibility:visible!important;height:auto!important;opacity:1!important;}'
    ].join('');
    document.head.appendChild(style);
  }

  function revealCartPagePackageProtectionLines() {
    installPackageProtectionVisibilityOverride();

    document.querySelectorAll('.cart-page .sm-cart-line-item--package-protection').forEach((lineItem) => {
      lineItem.style.setProperty('display', 'grid', 'important');
      lineItem.style.setProperty('visibility', 'visible', 'important');
      lineItem.style.setProperty('height', 'auto', 'important');
      lineItem.style.setProperty('opacity', '1', 'important');

      const row = lineItem.closest('tr');

      if (row) {
        row.style.setProperty('display', 'table-row', 'important');
        row.style.setProperty('visibility', 'visible', 'important');
      }
    });
  }

  function normalizeOptionText(value) {
    return String(value || '').trim().replace(/\s+/g, ' ').toLowerCase();
  }

  function getProductJson(handle) {
    if (!handle) {
      return Promise.resolve(null);
    }

    if (productJsonCache.has(handle)) {
      return productJsonCache.get(handle);
    }

    const root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
    const productPromise = fetch(`${root}products/${encodeURIComponent(handle)}.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then((response) => (response.ok ? response.json() : null))
      .catch(() => null);

    productJsonCache.set(handle, productPromise);

    return productPromise;
  }

  function findVariantImageForOption(product, optionPosition, label) {
    if (!product || !Array.isArray(product.variants) || !optionPosition || !label) {
      return null;
    }

    const optionKey = `option${optionPosition}`;
    const normalizedLabel = normalizeOptionText(label);
    const matchedVariant = product.variants.find((variant) => {
      return normalizeOptionText(variant && variant[optionKey]) === normalizedLabel && variant.featured_image && variant.featured_image.src;
    });

    return matchedVariant && matchedVariant.featured_image ? matchedVariant.featured_image.src : null;
  }

  function constrainShopifyImageWidth(src, width) {
    try {
      const imageUrl = new URL(src, window.location.origin);
      imageUrl.searchParams.set('width', String(width));
      return imageUrl.toString();
    } catch (error) {
      return src;
    }
  }

  function replaceFallbackSwatchWithThumbnail(label, imageSrc, labelText) {
    if (!label || !imageSrc || label.dataset.smVariantThumbnailFixed === 'true') {
      return;
    }

    label.classList.remove('block-swatch');
    label.classList.add('thumbnail-swatch', 'sm-js-variant-thumbnail');
    label.textContent = '';

    const srLabel = document.createElement('span');
    srLabel.className = 'sr-only';
    srLabel.textContent = labelText;

    const image = document.createElement('img');
    image.src = constrainShopifyImageWidth(imageSrc, 136);
    image.alt = '';
    image.loading = 'lazy';
    image.sizes = '(max-width: 699px) 48px, 68px';
    image.className = 'sm-variant-thumbnail__image';

    label.append(srLabel, image);
    label.dataset.smVariantThumbnailFixed = 'true';
  }

  function repairVariantThumbnailFallbacks() {
    document.querySelectorAll('variant-picker[handle]').forEach((picker) => {
      const fallbackLabels = [];

      picker.querySelectorAll('.variant-picker__option-values').forEach((container) => {
        if (!container.querySelector('.thumbnail-swatch')) {
          return;
        }

        container.querySelectorAll('label.block-swatch').forEach((label) => {
          fallbackLabels.push(label);
        });
      });

      if (!fallbackLabels.length) {
        return;
      }

      getProductJson(picker.getAttribute('handle')).then((product) => {
        if (!product) {
          return;
        }

        fallbackLabels.forEach((label) => {
          const input = label.htmlFor ? document.getElementById(label.htmlFor) : null;
          const optionPosition = input ? input.dataset.optionPosition : null;
          const labelText = label.textContent.trim().replace(/\s+/g, ' ');
          const imageSrc = findVariantImageForOption(product, optionPosition, labelText);

          if (imageSrc) {
            replaceFallbackSwatchWithThumbnail(label, imageSrc, labelText);
          }
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    syncBarsFromMarkup();
    refreshCart(false);
    refreshCartAfterDeferredRendering();
    repairVariantThumbnailFallbacks();
    revealCartPagePackageProtectionLines();

    document.addEventListener('click', (event) => {
      if (shouldRefreshFromEventTarget(event.target)) {
        refreshCart(true);
        revealCartPagePackageProtectionLines();
      }
    });

    document.addEventListener('change', (event) => {
      if (shouldRefreshFromEventTarget(event.target)) {
        refreshCart(true);
        revealCartPagePackageProtectionLines();
      }
    });

    [
      'cart:change',
      'cart:refresh',
      'cart:update',
      'cart:updated',
      'cart:rerender',
      'line-item:change:end',
      'variant:add',
      'product:add'
    ].forEach((eventName) => {
      document.addEventListener(eventName, () => {
        refreshCart(true);
        revealCartPagePackageProtectionLines();
      });
    });

    new MutationObserver(() => {
      window.clearTimeout(observerTimer);
      observerTimer = window.setTimeout(() => {
        syncBarsFromMarkup();
        refreshCart(false);
        updateShippingEstimatorRates();
        repairVariantThumbnailFallbacks();
        revealCartPagePackageProtectionLines();
      }, 80);
    }).observe(document.body, { childList: true, subtree: true });
  });
})();
